import React from 'react'

import { Avatar, Table, Tag} from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchHeroFollowingList,
} from '../../../../modules/heroLink'
import { HeroType } from '../../../../config'

export const HeroFollowing = ({ data }) => {
  const dispatch = useDispatch()

  const { heroFollowingList } = useSelector(
    (state) => ({
      heroFollowingList: state.heroLink.heroFollowingList.heroLinkFollowingDtoList
    }),
    []
  )

  const GetStatusColor = (status) => {
    let color = ''
    if (status !== null) {
      switch (status.toUpperCase()) {
        case 'PENDING':
          color = 'gold'
          break
        case 'APPROVED':
          color = 'green'
          break
        case 'REJECT':
          color = 'red'
          break
        case 'EXPIRED':
          color = 'volcano'
          break
        default:
          break
      }
    }
    return color
  }

  const columns = [
    {
      title: '',
      dataIndex: 'image',
      key: 'image',
      render: (name, row) => (
        <Avatar src={row.image} />
      )
    },
    {
      title: 'Name',
      dataIndex: 'heroName',
      key: 'heroName'
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroType',
      key: 'heroType',
      render: (name, row) => {
        return <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
  ]

  function fetch() {
    dispatch(fetchHeroFollowingList(data.id))
  }

  useDeepEffect(() => {
    if (!isEmpty(data)) {
      fetch()
    }
  }, [data])

  return (
    <Table
      rowKey={(record) => record.id}
      dataSource={heroFollowingList}
      columns={columns}
    />
  )
}

export default HeroFollowing
